import { render, staticRenderFns } from "./CardResumenServices.vue?vue&type=template&id=5d0c3f9a&scoped=true&lang=pug&"
import script from "./CardResumenServices.vue?vue&type=script&lang=js&"
export * from "./CardResumenServices.vue?vue&type=script&lang=js&"
import style0 from "./CardResumenServices.vue?vue&type=style&index=0&id=5d0c3f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c3f9a",
  null
  
)

export default component.exports